import { Component, ElementRef, Renderer2, forwardRef, Inject, ChangeDetectorRef } from '@angular/core';
import { XeroService } from 'sharedFeatures/sharedServices';
import { NewPlanForm, NewPlanFormBodyComponent } from 'sharedFeatures/newplan-win';
import { CreatePlanLoaderPopup } from "sharedFeatures/newplan-win/create-plan-loader-popup";
import { Xi4DataAssociationsBase } from './xi-4-associations-base.component';
import {dialogCreationActions} from "sharedFeatures/store";
import { select } from '@angular-redux/store';
import {Observable, Subject, throwError as observableThrowError} from 'rxjs';
import {catchError, filter, take, takeUntil} from 'rxjs/operators';
import { AuthUtils } from "sharedFeatures/utils";
import {AuthData} from "sharedFeatures/sharedModels";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { XeroLinksComponent } from '../../xeroLinks';
import { ScrollComponent } from '../../scroll/scrolldiv.component';
import { LoadingSpinnerService } from 'sharedGuiSmall/sharedServices/loadingSpinner.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xi-4-associations-form-body',
    templateUrl: './xi-4-associations-form-body.component.html',
    styleUrls: ['./xi-4-associations-form-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, ScrollComponent, XeroLinksComponent, TranslateModule]
})
export class Xi4DataAssociationsFormBodyComponent extends Xi4DataAssociationsBase {

    parent: NewPlanForm;
    parentBody: NewPlanFormBodyComponent;

    @select(['appData', 'appComponent'])
    readonly appComponent$!: Observable<any>;
    appComponent: any = null;

    @select(['account', 'authData'])
    readonly authData$!: Observable<AuthData>;
    authData: AuthData = new AuthData();

    // Unsubscribe event
    readonly storeUnsubscribe = new Subject<void>();

    constructor(
        el: ElementRef,
        r: Renderer2,
        xeroService: XeroService,
        @Inject(forwardRef(() => NewPlanForm)) parent: NewPlanForm,
        chDet: ChangeDetectorRef,
        loadingSpinnerService: LoadingSpinnerService
    ) {
        super(el, r, xeroService, chDet, loadingSpinnerService);
        this.parent = parent;
        this.parentBody = this.parent.getBodyComponent();
    }

    ngOnInit() {
        // Subscribe on the redux store
        this.subscribeReduxStore();
    }

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.appComponent$.pipe(
            takeUntil(this.storeUnsubscribe))
            .subscribe(x => {
                this.appComponent = x;
            });

        this.authData$.pipe(
            catchError(error => {
                console.error('Get AuthData error', error);
                return observableThrowError(error);
            }),
            filter(x => !!x),
            take(1),)
            .subscribe(authData => {
                    if (authData != null) {
                        this.authData = authData;
                        this.isXeroEmployee = AuthUtils.isBetaFeatureActive(this.authData, 'XeroEmployee');
                    }
                });
    }

    ngAfterViewInit() {

        this.parent.getOnClose().subscribe(this.onParentClose.bind(this));

    }

    public getWorkMode(): boolean {

        if (this.parentBody.isConnectToExistingModeEnabled)
            return true;
        else
            return Xi4DataAssociationsBase.workMode;
    }

    public getPlanGuid(): string {

        if (this.parentBody.isConnectToExistingModeEnabled)
            return this.appComponent.planData.planGUID;
        else
            return '';
    }

    public reload(): void {

        if (this.parentBody.isConnectToExistingModeEnabled)
            this.loadComponentAssociations(true, false, this.getPlanGuid(), (failed: boolean) => { if (failed) this.parent.close(); else this.parent.enableContinue()});
        else
            this.loadComponentAssociations(false, true, '', (failed: boolean) => { if (failed) this.parent.close(); else this.parent.enableContinue() });
    }

    onCreatePlan() {

        let isExistingAssociations = this.parentBody.isConnectToExistingModeEnabled;
        let planGuid = this.getPlanGuid();

        if (isExistingAssociations) {
            this.xeroService.ConnectXeroPlan(planGuid, () => {
                this.processConnectCreate(isExistingAssociations);
            });
        }
        else
            this.processConnectCreate(isExistingAssociations);

    }

    protected processConnectCreate(isExistingAssociations: boolean) {
        let loadingPopup = <CreatePlanLoaderPopup>this.parent.getDialogCreator().createDialog(CreatePlanLoaderPopup);

        let appElem = document.body;

        let x = (DomSmallUtils.width(appElem) - loadingPopup.width) / 2;
        let y = (DomSmallUtils.height(appElem) - loadingPopup.height) / 2;

        loadingPopup.setModal(true);
        loadingPopup.show(x, y);

        if (isExistingAssociations)
        {
            this.xeroService.SetImportedComponentAssociations(this.ca, this.getPlanGuid()).then((data) => {
                if (typeof (data.success) == "undefined") return;

                if (data.success)
                {
                    if (isExistingAssociations)
                        this.parent.connectExistingPlanToXero(this.getPlanGuid(), () => { document.location.reload(); });
                    else
                        this.parent.createPlan(() => { loadingPopup.close(); });
                }
                else
                {
                    loadingPopup.close();
                    this.parent.close();
                }

            });
        }
        else
        {
            this.xeroService.SetComponentAssociations(this.ca, super.plAccountsData, super.bsAccountsData).then((data) => {
                if (typeof (data.success) == "undefined") return;

                if (data.success)
                {
                    if (isExistingAssociations)
                        this.parent.connectExistingPlanToXero(this.getPlanGuid(), () => { document.location.reload(); });
                    else
                        this.parent.createPlan(() => { loadingPopup.close(); });
                }
                else
                {
                    loadingPopup.close();
                    this.parent.close();
                }

            });
        }

    }

    protected onParentClose(): void {

        super.onParentClose();
        this.r.setStyle(this.parent.getBodyComponent().saveClosePanePlaceEl(), 'height', '0px');

    }


    onClose() {
        dialogCreationActions.setNewPlanDialogOpen(false);
        this.parent.showSetupWarning();

    }

    public getScrollPane(): ScrollComponent {

        return this.parentBody.getScrollPane();

    }


}
